import React from "react"
import {FieldViewSize} from "../../../../const";
import FieldSelectTask from "../../select-task";
import TaskTypeIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5";
import Task from "../../../../../model2/task/task";

type Props = {
    className   : string,
    field       : FieldSelectTask
    value       : Task
    onClick     : () => void,
    children    : any
    size?       : any

}

const debug = false
// const debug = "FieldSelectTask_FormValueNotEmpty"

export default function FieldSelectTask_FormValueNotEmpty(props: Props) {

    debug && console.log(debug, "props", props)

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)
    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form no-wrap", props.className, {
        'h-36'  : size === FieldViewSize.DEFAULT,
        'h-28'  : size === FieldViewSize.SMALL,
    })

    return (
        <>
            <div className={valueClasses} onClick={props.onClick}>
                <TaskTypeIcon className="icon m-r-10" taskTypeId={props.value.taskTypeId}/>
                <span className="txt-truncate">{props.value?.title}</span>
            </div>
            {props.children}
        </>
    );
}
